export default "__VITE_ASSET__kDA5cPiS__"